document.addEventListener("DOMContentLoaded", function () {
  
  const persons = document.querySelectorAll(".person");
  persons.forEach((person) => {
    person.addEventListener("mousedown", () => {
      const wasActive = person.classList.contains("is-active-person");
      
      // Remove active class from all persons
      persons.forEach(p => p.classList.remove("is-active-person"));
      
      // If this person wasn't active, make it active
      if (!wasActive) {
        person.classList.add("is-active-person");
      }
    });
         person.addEventListener("mouseover", () => {
       // Remove active class from all persons
       persons.forEach(p => p.classList.remove("is-active-person"));
       
       // Add active class to hovered person
       person.classList.add("is-active-person");
     });
     
     person.addEventListener("mouseout", () => {
       // Remove active class from this person
       person.classList.remove("is-active-person");
     });
  });

  // Mobile hover effect showcase for team section
  if (window.innerWidth <= 768) {
    const firstPerson = document.querySelector(".person");
    
    if (firstPerson) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-active-person");

            setTimeout(() => {
                entry.target.classList.remove("is-active-person");
            }, 3000);
            
            // Stop observing after the effect has been triggered
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 1 // Trigger when 50% of the element is visible
      });

      observer.observe(firstPerson);
    }
  }
});
